import Vue from 'vue'
import Router from 'vue-router'
import Channel from '@/components/views/Channel/Channel'
import category from '@/config/categorys.js';
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: `/channel/cid/${category.list[0].name}`
    },
    {
      path: '/channel/cid/:cid/',
      name: 'channel',
      component: Channel
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js